import React from 'react';
import AsyncSelect from 'react-select/async';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faPlus } from '@fortawesome/pro-solid-svg-icons';

import { searchProperties, searchAllProperties } from 'components/research_property/api';
import 'styles/entity_selector.scss';

const Option = (props) => {
  const { innerProps, innerRef } = props;

  if (props.data.type == 'addProperty') {
    return (
      <div ref={innerRef} {...innerProps} className="entity" onClick={() => props.data.onClick()}>
        <FontAwesomeIcon className="type-icon" icon={faPlus} pull="left" size="lg"/>
        <div>
          <div>
            <strong>{props.label}</strong>
          </div>
        </div>
      </div>
    );
  } else {
    const { property } = props.data;
    let label;

    if (property.address === property.name) {
      label = (
        <div>
          <strong>{property.address}</strong> - {property.addressTwoLine[1]}
        </div>
      );
    } else {
      label = (
        <div>
          <strong>{property.name}</strong> - {property.addressOneLine}
        </div>
      );
    }

    return (
      <div ref={innerRef} {...innerProps} className="entity">
        <FontAwesomeIcon className="type-icon" icon={faBuilding} pull="left" size="lg"/>
        <div>
          {label}
          <small>Source: {property.databaseName}</small>
        </div>
      </div>
    );
  }
};

export default class AssociatedPropertySelector extends React.Component {
  static propTypes = {
    allDatabases: PropTypes.bool,
    createText: PropTypes.string,
    excludedPropertyIds: PropTypes.arrayOf(PropTypes.number),
    onCreateClicked: PropTypes.func,
    onModelAdded: PropTypes.func.isRequired
  };

  static defaultProps = {
    allDatabases: true
  }

  loadPropertyOptions = (inputValue, callback) => {
    const search = this.props.allDatabases ? searchAllProperties : searchProperties;

    search(inputValue).then((properties) => {
      const { createText, excludedPropertyIds, onCreateClicked } = this.props;

      if (excludedPropertyIds) properties = properties.filter(p => !excludedPropertyIds.includes(p.id));

      const options = properties.map((property) => {
        return {
          value: property.id,
          label: property.name,
          type: 'Research::Property',
          property
        };
      });

      if (onCreateClicked && createText) {
        options.push({ type: 'addProperty', label: createText, onClick: onCreateClicked });
      }

      callback(options);
    });
  }

  onSelected = (selection) => {
    this.props.onModelAdded({
      associatedModelId: selection.value,
      associatedModelType: selection.type,
      name: selection.label
    });
  }

  render() {
    return (
      <AsyncSelect
        autoFocus
        className="entity-selector"
        components={{ Option }}
        loadOptions={this.loadPropertyOptions}
        placeholder="Search Database Properties ..."
        onChange={this.onSelected}
      />
    );
  }
}
